import { DASH_PLACEHOLDER } from "../constants/dashPlaceholder";
import { formatNumber } from "../constants/utils";

/**
 * Transforms handling units value by replacing zero with a dash placeholder.
 *
 * @param value - The numeric/string value representing handling units
 * @returns The original value if non-zero, otherwise returns a dash placeholder
 *
 * @example
 * ```typescript
 * handlingUnitsTransformer(5) // returns 5
 * handlingUnitsTransformer(0) // returns DASH_PLACEHOLDER
 * ```
 */
export function handlingUnitsTransformer(value: number | string) {
  return Number(value)
    ? value !== 0
      ? formatNumber(Number(value))
      : DASH_PLACEHOLDER
    : DASH_PLACEHOLDER;
}
